import { goodsBelongLabels } from 'json/mall-options'
export let integralExchangeTableLabels = [
  {
    label: '兑换用户',
    value: 'mallUserNickName'
  },
  {
    label: '用户等级',
    value: 'placeUserMemberLevelInformation.levelName'
  },
  {
    label: '消费积分',
    value: 'pay_real'
  },
  {
    label: '订单状态',
    value: 'order_status'
  }
]
export let filterLabels = [
  {
    label: '订单时间',
    type: 'time-slot',
    startName: 'orderCreateTimeStart', // 返回数据时，开始时间的字段名
    endName: 'orderCreateTimeEnd', // 返回数据时，结束时间的字段名
    value: 'orderTime'
  },
  {
    label: '商品类型',
    type: 'select',
    value: 'goodsType',
    clearable: true,
    props: {
      label: 'name',
      value: 'value'
    },
    options: []
  },
  {
    label: '经营类型', //
    type: 'select',
    value: 'goodsBelong',
    clearable: true,
    options: goodsBelongLabels
  },
  {
    label: '订单状态',
    type: 'select',
    value: 'orderStatus',
    clearable: true,
    options: [
      {
        label: '已支付',
        value: 'PAID'
      },
      {
        label: '待发货',
        value: 'SHIPPED'
      },
      {
        label: '已关闭',
        value: 'CLOSED'
      },
      {
        label: '已完成',
        value: 'COMPLETED'
      }
    ]
  },
  {
    label: '商品分组',
    type: 'select',
    value: 'goodsGroupName',
    clearable: true,
    props: {
      label: 'name',
      value: 'name'
    },
    options: []
  },
  {
    label: '地区',
    type: 'select',
    value: 'goodsAddresses',
    multiple: true,
    clearable: true,
    options: []
  },
  {
    label: '用户等级',
    type: 'select',
    value: 'memberLevel',
    clearable: true,
    options: []
  }
]
